import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="px-4 md:px-10 lg:px-20 py-12 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-4xl font-bold mb-8 text-left">Privacy Policy</h1>

      <p className="mb-6 text-left leading-relaxed">
        At <strong>Daily Go</strong>, your privacy is of utmost importance to us. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our website, brochures, or services.
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">1. Information We Collect</h2>
        <p className="text-left leading-relaxed">
          We may collect information such as your name, email address, phone number, and any other details you submit voluntarily through our contact forms or while communicating with us.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">2. Use of Information</h2>
        <ul className="list-disc ml-6 text-left leading-relaxed">
          <li>Respond to inquiries and service requests</li>
          <li>Process orders or manage user accounts</li>
          <li>Improve our services and offerings</li>
          <li>Send important updates or promotional content (only if opted-in)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">3. Brochure & Content Usage Policy</h2>
        <ul className="list-disc ml-6 text-left leading-relaxed">
          <li>All brochures, marketing materials, and digital resources belong to <strong>Daily Go</strong>.</li>
          <li>Do not copy, redistribute, or misuse our brochures without prior written consent.</li>
          <li><strong>Credentials, logos, or brand identifiers cannot be removed or altered.</strong></li>
          <li>Unauthorized usage will lead to strict action.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">4. Cookies and Tracking</h2>
        <p className="text-left leading-relaxed">
          We may use cookies and similar technologies to analyze traffic and enhance your experience. You can control cookie preferences through your browser settings.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">5. Data Protection</h2>
        <p className="text-left leading-relaxed">
          We employ industry-standard security practices to protect your data. However, please note that no method of data transmission over the internet is completely secure.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">6. Third-Party Sharing</h2>
        <p className="text-left leading-relaxed">
          We do not sell or rent your information. Data may only be shared with trusted third-party service providers necessary to deliver our services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">7. Data Deletion</h2>
        <p className="text-left leading-relaxed">
          Users do not have direct access to delete their data from our website. To request deletion, please email us at:{" "}
          <a href="mailto:office-info@dailygolive.in" className="text-blue-600 underline">
            office-info@dailygolive.in
          </a>.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">8. Changes to This Policy</h2>
        <p className="text-left leading-relaxed">
          We may revise this policy periodically. Updates will be reflected on this page with a new effective date.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2 text-left">9. Contact Us</h2>
        <p className="text-left leading-relaxed">
          For any questions or concerns regarding this policy, please email us at:{" "}
          <a href="mailto:office-info@dailygolive.in" className="text-blue-600 underline">
            office-info@dailygolive.in
          </a>.
        </p>
      </section>

      <p className="text-sm text-gray-500 text-left">Last updated: August 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
